import type { CustomerOrderStatus } from '../../customerOrdersApi'

export type OrderVisualStatus = CustomerOrderStatus | 'delivered'
export type OrderSortOption = 'recent-desc' | 'recent-asc' | 'price-desc' | 'price-asc'
export type OrderDateFilterOption = 'all' | 'last-30-days' | 'last-3-months' | 'last-year' | 'custom'
export type OrderPageSizeOption = 10 | 20 | 50

export const ORDER_SORT_OPTIONS: OrderSortOption[] = ['recent-desc', 'recent-asc', 'price-desc', 'price-asc']
export const ORDER_STATUS_FILTER_OPTIONS: OrderVisualStatus[] = [
  'created',
  'paid',
  'shipped',
  'delivered',
  'cancelled',
]
export const ORDER_PAGE_SIZE_OPTIONS: OrderPageSizeOption[] = [10, 20, 50]

export const DELIVERY_ESTIMATED_WINDOW_MS = 7 * 24 * 60 * 60 * 1000
